import * as React from "react"
import { useTimeTableColor } from '../../state/storeTimeTableColor';
import { usePostMeta } from '../../hooks/usePostMeta';

const SaveColorBtn = () => {
	const { appendDataPost } = usePostMeta();
	const rgba_first_bg = useTimeTableColor( ( state ) => state.rgba_first_bg );
	const rgba_second_bg = useTimeTableColor(
		( state ) => state.rgba_second_bg
	);
	const rgba_even_bg = useTimeTableColor( ( state ) => state.rgba_even_bg );
	const rgba_odd_bg = useTimeTableColor( ( state ) => state.rgba_odd_bg );
	const rgba_border_clr = useTimeTableColor(
		( state ) => state.rgba_border_clr
	);
	const rgba_light_bg = useTimeTableColor( ( state ) => state.rgba_light_bg );
	const rgba_border_size = useTimeTableColor(
		( state ) => state.rgba_border_size
	);
	const rgba_border_style = useTimeTableColor(
		( state ) => state.rgba_border_style
	);
	const ShowHightLight = useTimeTableColor(
		( state ) => state.ShowHightLight
	);
	const rgba_first_text = useTimeTableColor(
		( state ) => state.rgba_first_text
	);
	const rgba_second_text = useTimeTableColor(
		( state ) => state.rgba_second_text
	);
	const rgba_light_text = useTimeTableColor(
		( state ) => state.rgba_light_text
	);
	const rgba_even_text = useTimeTableColor(
		( state ) => state.rgba_even_text
	);
	const rgba_odd_text = useTimeTableColor( ( state ) => state.rgba_odd_text );
	const [ Firstbg, setFirstBG ] = React.useState( { r: 0, g: 0, b: 0, a: 0 } );
	const [ Secondbg, setSecondBG ] = React.useState( { r: 0, g: 0, b: 0, a: 0 } );
	const [ Evenbg, setEvenBG ] = React.useState( { r: 0, g: 0, b: 0, a: 0 } );
	const [ Oddbg, setOddBG ] = React.useState( { r: 0, g: 0, b: 0, a: 0 } );
	const [ HightLightbg, setHightLightBG ] = React.useState( {
		r: 0,
		g: 0,
		b: 0,
		a: 0,
	} );
	const [ BorderColor, setBorderColor ] = React.useState( {
		r: 0,
		g: 0,
		b: 0,
		a: 0,
	} );
	const [ BorderStyle, setBorderStyle ] = React.useState( {} );
	const [ BorderSize, setBorderSize ] = React.useState( {} );
	const [ FirstTextColor, setFirstTextColor ] = React.useState( {
		r: 0,
		g: 0,
		b: 0,
		a: 0,
	} );
	const [ SecondTextColor, setSecondTextColor ] = React.useState( {
		r: 0,
		g: 0,
		b: 0,
		a: 0,
	} );
	const [ EvenTextColor, setEvenTextColor ] = React.useState( {
		r: 0,
		g: 0,
		b: 0,
		a: 0,
	} );
	const [ OddTextColor, setOddTextColor ] = React.useState( {
		r: 0,
		g: 0,
		b: 0,
		a: 0,
	} );
	const [ HightLightTextColor, setHightLightTextColor ] = React.useState( {
		r: 0,
		g: 0,
		b: 0,
		a: 0,
	} );

	// React.useEffect(() => {

	//     setFirstBG(rgba_first_bg)
	//     setSecondBG(rgba_second_bg)
	//     setEvenBG(rgba_even_bg)
	//     setOddBG(rgba_odd_bg)
	//     setHightLightBG(rgba_light_bg)
	//     setBorderColor(rgba_border_clr)
	//     setBorderStyle(rgba_border_style)
	//     setBorderSize(rgba_border_size)
	//     setFirstTextColor(rgba_first_text)
	//     setSecondTextColor(rgba_second_text)
	//     setEvenTextColor(rgba_even_text)
	//     setOddTextColor(rgba_odd_text)
	//     setHightLightTextColor(rgba_light_text)

	// }, [
	//     rgba_first_bg, rgba_second_bg, rgba_even_bg, rgba_odd_bg, rgba_light_bg,
	//     rgba_border_clr, rgba_border_style, rgba_border_size, rgba_first_text,
	//     rgba_second_text, rgba_even_text, rgba_odd_text, rgba_light_text
	// ])

	React.useEffect( () => {
		setFirstBG( rgba_first_bg );
	}, [ rgba_first_bg ] );
	React.useEffect( () => {
		setSecondBG( rgba_second_bg );
	}, [ rgba_second_bg ] );
	React.useEffect( () => {
		setEvenBG( rgba_even_bg );
	}, [ rgba_even_bg ] );
	React.useEffect( () => {
		setOddBG( rgba_odd_bg );
	}, [ rgba_odd_bg ] );
	React.useEffect( () => {
		setHightLightBG( rgba_light_bg );
	}, [ rgba_light_bg ] );
	React.useEffect( () => {
		setBorderSize( rgba_border_size );
	}, [ rgba_border_size ] );
	React.useEffect( () => {
		setBorderColor( rgba_border_clr );
	}, [ rgba_border_clr ] );
	React.useEffect( () => {
		setBorderStyle( rgba_border_style );
	}, [ rgba_border_style ] );
	React.useEffect( () => {
		setFirstTextColor( rgba_first_text );
	}, [ rgba_first_text ] );
	React.useEffect( () => {
		setSecondTextColor( rgba_second_text );
	}, [ rgba_second_text ] );
	React.useEffect( () => {
		setEvenTextColor( rgba_even_text );
	}, [ rgba_even_text ] );
	React.useEffect( () => {
		setOddTextColor( rgba_odd_text );
	}, [ rgba_odd_text ] );
	React.useEffect( () => {
		setHightLightTextColor( rgba_light_text );
	}, [ rgba_light_text ] );

	const clickHandle = () => {
		if (
			Firstbg.r > 0 ||
			Firstbg.g > 0 ||
			Firstbg.b > 0 ||
			Firstbg.a > 0
		) {
			const metaSet = { value: Firstbg, meta: 'firstbg' };
			appendDataPost( metaSet );
			setFirstBG( { r: 0, g: 0, b: 0, a: 0 } );
		}
		if (
			FirstTextColor.r > 0 ||
			FirstTextColor.g > 0 ||
			FirstTextColor.b > 0 ||
			FirstTextColor.a > 0
		) {
			const metaSet = { value: FirstTextColor, meta: 'firstclr' };
			appendDataPost( metaSet );
			setFirstTextColor( { r: 0, g: 0, b: 0, a: 0 } );
		}

		if (
			Secondbg.r > 0 ||
			Secondbg.g > 0 ||
			Secondbg.b > 0 ||
			Secondbg.a > 0
		) {
			const metaSet = { value: Secondbg, meta: 'secondbg' };
			appendDataPost( metaSet );
			setSecondBG( { r: 0, g: 0, b: 0, a: 0 } );
		}
		if (
			SecondTextColor.r > 0 ||
			SecondTextColor.g > 0 ||
			SecondTextColor.b > 0 ||
			SecondTextColor.a > 0
		) {
			const metaSet = { value: SecondTextColor, meta: 'secondclr' };
			appendDataPost( metaSet );
			setSecondTextColor( { r: 0, g: 0, b: 0, a: 0 } );
		}

		if ( Evenbg.r > 0 || Evenbg.g > 0 || Evenbg.b > 0 || Evenbg.a > 0 ) {
			const metaSet = { value: Evenbg, meta: 'evenbg' };
			appendDataPost( metaSet );
			setEvenBG( { r: 0, g: 0, b: 0, a: 0 } );
		}
		if (
			EvenTextColor.r > 0 ||
			EvenTextColor.g > 0 ||
			EvenTextColor.b > 0 ||
			EvenTextColor.a > 0
		) {
			const metaSet = { value: EvenTextColor, meta: 'evenclr' };
			appendDataPost( metaSet );
			setEvenTextColor( { r: 0, g: 0, b: 0, a: 0 } );
		}
		if ( Oddbg.r > 0 || Oddbg.g > 0 || Oddbg.b > 0 || Oddbg.a > 0 ) {
			const metaSet = { value: Oddbg, meta: 'oddbg' };
			appendDataPost( metaSet );
			setOddBG( { r: 0, g: 0, b: 0, a: 0 } );
		}
		if (
			OddTextColor.r > 0 ||
			OddTextColor.g > 0 ||
			OddTextColor.b > 0 ||
			OddTextColor.a > 0
		) {
			const metaSet = { value: OddTextColor, meta: 'oddclr' };
			appendDataPost( metaSet );
			setOddTextColor( { r: 0, g: 0, b: 0, a: 0 } );
		}
		if (
			HightLightbg.r > 0 ||
			HightLightbg.g > 0 ||
			HightLightbg.b > 0 ||
			HightLightbg.a > 0
		) {
			const metaSet = { value: HightLightbg, meta: 'highlightbg' };
			appendDataPost( metaSet );
			setHightLightBG( { r: 0, g: 0, b: 0, a: 0 } );
		}
		if (
			HightLightTextColor.r > 0 ||
			HightLightTextColor.g > 0 ||
			HightLightTextColor.b > 0 ||
			HightLightTextColor.a > 0
		) {
			const metaSet = {
				value: HightLightTextColor,
				meta: 'highlightclr',
			};
			appendDataPost( metaSet );
			setHightLightTextColor( { r: 0, g: 0, b: 0, a: 0 } );
		}
		if (
			rgba_border_clr.r > 0 ||
			rgba_border_clr.g > 0 ||
			rgba_border_clr.b > 0 ||
			rgba_border_clr.a > 0
		) {
			const metaSet = { value: rgba_border_clr, meta: 'borderclr' };
			appendDataPost( metaSet );
			setBorderColor( { r: 0, g: 0, b: 0, a: 0 } );
		}
		if ( rgba_border_style ) {
			const metaSet = { value: rgba_border_style, meta: 'borderstyle' };
			appendDataPost( metaSet );
			setBorderStyle( '' );
		}

		if ( rgba_border_size ) {
			const metaSet = { value: rgba_border_size, meta: 'bordersize' };
			appendDataPost( metaSet );
			setBorderSize( 0 );
		}
	};

	return (
		<button
			className="bg-blue-600 px-2 py-2 rounded-md text-white"
			onClick={ clickHandle }
		>
			Save The Change
		</button>
	);
};

export default SaveColorBtn;
